/**
 * JavaScript Utility - string/format
 * @author 서명환 <mhseo@ulalalab.com>
 */
function format(format = '', value = {}) {
  return Object.entries(value).reduce(
    (result, [key, value = '']) => result.replaceAll(`{${key}}`, value),
    format
  );
}

export default format;
